<!-- 广告位租控 -->
<template>
  <div class="ad-control-container">
    <!-- 1. 顶部统计卡片 -->
    <div class="stat-row">
      <div v-for="(item, index) in summaryCards" :key="index" class="stat-card">
        <div class="stat-label">{{ item.label }}</div>
        <div class="stat-value" :style="{ color: item.color }">
          {{ item.value }} <span class="arrow-up">个</span>
        </div>
      </div>
    </div>

    <!-- 2. 筛选区域 -->
    <div class="filter-bar">
      <span class="filter-label">选择位置：</span>
      <el-select
        v-model="currentAsset"
        size="small"
        placeholder="请选择"
        style="width: 200px"
        @change="assetChange"
      >
        <el-option
          v-for="item in assetList"
          :label="item.assetName"
          :value="item.assetId"
          :key="item.assetId"
        />
      </el-select>
    </div>

    <!-- 3. 图例说明 -->
    <div class="legend-bar">
      <span class="legend-title">图例：</span>
      <div v-for="lg in legendList" :key="lg.text" class="legend-item">
        <span
          class="color-box"
          :style="{
            backgroundColor: lg.bg,
            borderColor: lg.border || 'transparent',
            borderStyle: lg.border ? 'solid' : 'none',
            borderWidth: '1px',
          }"
        ></span>
        <span class="text">{{ lg.text }}</span>
      </div>
    </div>

    <!-- 4. 广告位网格主容器 -->
    <div class="grid-container">
      <div class="ad-grid">
        <div
          v-for="item in resourceListZK"
          :key="item.assetId"
          class="ad-item-box"
          :class="['status-' + item.currentStatus]"
        >
          <div class="ad-title">{{ item.resourceName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { formatDate } from "../../../utils/dateUtil.js";
import {
  mapValuesToArray,
  commonFormatter,
  safeDivide,
  filterEmptyFields,
} from "../../../utils/tool.js";

const TAG = "广告位租控";

export default {
  data() {
    return {
      currentAsset: "",

      // 顶部汇总统计
      summaryCards: [
        {
          label: "总广告位数",
          value: "",
          unit: "个",
          color: "#409EFF",
          key: "totalCount",
        },
        {
          label: "已出租",
          value: "",
          unit: "个",
          color: "#67C23A",
          key: "rentedCount",
        },
        {
          label: "空置可租",
          value: "",
          unit: "个",
          color: "#E6A23C",
          key: "availableCount",
        },
        {
          label: "已预订",
          value: "",
          unit: "个",
          color: "#409EFF",
          key: "reservedCount",
        },
        {
          label: "即将到期",
          value: "",
          unit: "个",
          color: "#F56C6C",
          key: "expiringCount",
        },
      ],

      // 图例配置
      legendList: [
        { text: "已出租", bg: "#52c41a" },
        { text: "空置可租", bg: "#ffffff", border: "#d9d9d9" },
        { text: "已预订", bg: "#ffffff", border: "#1890ff" },
        { text: "即将到期", bg: "#ff4d4f" },
      ],
    };
  },

  computed: {
    ...mapState("asset", ["assetList", "resourceListZK"]),
  },

  mounted() {
    this.search();
    this.searchStatics();
  },

  methods: {
    ...mapActions("asset", [
      "listWithAssetHandler", // 租控图，车位，广告位，铺位
      "getStatisticsHandler", // 租控图，车位，广告位，铺位
    ]),

    search() {
      const params = { resourceType: "AD_SPACE", assetId: this.currentAsset };
      const noEmptyParams = filterEmptyFields(params);
      this.listWithAssetHandler(noEmptyParams).then((res) => {
        this.currentAsset = _.get(this.assetList, "[0].assetId");
        console.log(TAG, "init this.currentAsset=", this.currentAsset);
        console.log(TAG, "init this.resourceListZK=", this.resourceListZK);
      });
    },

    searchStatics() {
      const params = { resourceType: "AD_SPACE" };
      this.getStatisticsHandler(params).then((obj) => {
        this.summaryCards = mapValuesToArray(this.summaryCards, obj);
        console.log(TAG, "init this.summaryCards=", this.summaryCards);
      });
    },

    assetChange() {
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$bg-main: #f0f2f5; // 页面整体背景
$bg-white: #ffffff; // 白色背景
$border-light: #ebeef5; // 浅色边框
$text-sub: #909399; // 次要文字颜色
$text-main: #333333; // 主文本颜色

/* 状态专用色 */
$color-rented: #52c41a; // 已出租 (绿色)
$color-reserved: #1890ff; // 已预订 (蓝色)
$color-vacant-border: #dcdfe6; // 空置边框 (灰色)
$color-expiring: #f5222d; // 即将到期 (红色)
$color-green: #52c41a; // 已出租-绿
$color-red: #ff4d4f; // 即将到期-红
$color-blue: #1890ff; // 已预订-蓝
$color-white: #fff; // 空闲-白色
$color-purple: #722ed1; // 装修中 (紫色)
$vacant-border: #dcdfe6; // 空置边框

.ad-control-container {
  // padding: 16px;
  // background-color: $bg-main;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;

  /* 顶部统计卡片 */
  .stat-row {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .stat-card {
      flex: 1;
      min-width: 180px;
      background: $bg-white;
      padding: 15px 20px;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      .stat-label {
        font-size: 13px;
        color: $text-sub;
        margin-bottom: 10px;
      }
      .stat-value {
        font-size: 24px;
        font-weight: 500;
        .arrow-up {
          font-size: 16px;
          margin-left: 2px;
        }
      }
    }
  }

  /* 筛选栏样式 */
  .filter-bar {
    background: $bg-white;
    padding: 12px 20px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid $border-light;
    text-align: left;
    .filter-label {
      font-size: 14px;
      font-weight: bold;
      color: $text-main;
      margin-right: 8px;
    }
  }

  /* 图例说明栏 */
  .legend-bar {
    background: $bg-white;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    border-bottom: 1px solid $border-light;

    .legend-title {
      font-size: 13px;
      font-weight: bold;
    }
    .legend-item {
      display: flex;
      align-items: center;
      gap: 6px;
      .color-box {
        width: 14px;
        height: 14px;
        border-radius: 2px;
        display: inline-block;
      }
      .text {
        font-size: 13px;
        color: $text-main;
      }
    }
  }

  /* 广告位网格区域 */
  .grid-container {
    background: $bg-white;
    padding: 30px;
    border-radius: 0 0 4px 4px;
    min-height: 400px;

    .ad-grid {
      display: grid;
      // 默认一排6个（对应图片中一排6个的比例）
      grid-template-columns: repeat(6, 1fr);
      gap: 16px;
    }
  }

  /* 广告位方块通用样式 */
  .ad-item-box {
    border-radius: 8px;
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    border: 1px solid transparent;

    .ad-title {
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .ad-status-text {
      font-size: 11px;
    }

    /* 状态样式 */
    // 已出租
    &.status-RENTED {
      background-color: $color-green;
      color: #fff;
    }

    // 即将到期
    &.status-expiring {
      background-color: $color-red;
      color: #fff;
    }

    // 已预定
    &.status-RESERVED {
      background-color: #fff;
      border: 1px solid $color-blue;
      color: $color-blue;
    }
    // 空闲可租
    &.status-AVAILABLE {
      background-color: $color-white;
      border: 1px solid $vacant-border;
      color: #999;
      .park-code {
        color: #555;
      }
    }

    // /* 不同状态的主题样式 */
    // &.status-rented {
    //   background-color: $color-rented;
    //   color: #fff;
    // }

    // &.status-vacant {
    //   background-color: #fff;
    //   border: 1px solid $color-vacant-border;
    //   color: $text-sub;
    //   .ad-title {
    //     color: #555;
    //   }
    // }

    // &.status-reserved {
    //   background-color: #fff;
    //   border: 2px solid $color-reserved; // 突出显示已预订的蓝色边框
    //   color: $color-reserved;
    // }

    // &.status-expiring {
    //   background-color: $color-expiring;
    //   color: #fff;
    // }

    &:hover {
      opacity: 0.9;
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
  }
}

/* 响应式适配：处理不同屏幕下的列数 */
@media screen and (max-width: 1200px) {
  .ad-control-container .grid-container .ad-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .ad-control-container .stat-row .stat-card {
    min-width: 45%;
  }
  .ad-control-container .grid-container .ad-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
